import styles from './Spinner.module.css';

interface SpinnerProps {
  message?: string;
  visible?: boolean;
}

export const Spinner = ({ message = 'Loading...', visible = true }: SpinnerProps) => {
  if (!visible) return null;

  return (
    <div className={styles['loading-container']}>
      <div
        className={styles['lds-spinner']}
        role="alert"
        aria-label={message}
        tabIndex={-1}
        aria-live="assertive"
        id="spinner"
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className={styles['loading-text']}>
        <span>{message}</span>
      </div>
    </div>
  );
};
